module.exports = __webpack_public_path__ + "img/5-2_04.db6bdedb.jpg";